import { BaseModel } from "model/BaseModel";
import HorarioDiaItem from "./HorarioDiaItem";

export default class HorarioDia implements BaseModel {
    id: number;
    codigo: string | null = null;
    nome: string;
    itens: HorarioDiaItem[];

    constructor(
        id = 0, 
        nome = '', 
        itens = []
    ) {
        this.id = id;
        this.nome = nome;
        this.itens = itens;
    }
}